import { H5, SkeletonContainer, SkeletonHeading } from '@snsw/react-component-library';
import { FeeRow } from 'components/FeeSummary/FeeRow';
import React from 'react';

const SkeletonBlock = () => <SkeletonHeading level={5} noMargin />;

export const SkeletonFeeRows = () => {
  return (
    <SkeletonContainer>
      <FeeRow feeName={<SkeletonBlock />} value={<SkeletonBlock />} />
      <FeeRow feeName={<SkeletonBlock />} value={<SkeletonBlock />} />

      <FeeRow isSummary feeName={<H5>Total due</H5>} value={<SkeletonBlock />} />
    </SkeletonContainer>
  );
};
